window._ = require('lodash');

// Import and expose Popper.js globally
window.Popper = require('@popperjs/core');

// Import and expose Tippy.js globally
try {
    const tippyModule = require('tippy.js');
    window.tippy = tippyModule.default || tippyModule;
    console.log('Tippy loaded:', typeof window.tippy);
} catch (error) {
    console.error('Failed to load tippy.js:', error);
}

try {
    require('bootstrap');
   

} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
